<template>
    <div class="modal fade" :id="idModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">

                <div class="modal-content" v-if="register">
                    <div class="modal-header">
                        <h5 class="modal-title">Registro de Embarcaciones Adicionales (Sancion)</h5><br>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <h6><b># Reincidencia :</b> {{ penalty_dts.number_relapse }} <div v-if="penalty_dts.number_relapse > 0" class="badge badge-primary"> Valido </div> <div v-else class="badge badge-danger">No Valido</div></h6>
                    
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12 col-md-4">
                                <label for="recipient-name" class="col-form-label">Criterio</label>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearch" value="name" checked>
                                    <label class="form-check-label" for="radios1">
                                        Nombre
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearch" value="enrollment">
                                    <label class="form-check-label" for="radios2">
                                        Matricula
                                    </label>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="recipient-name" class="col-form-label">{{searchType}}</label>
                                    <vue-bootstrap-typeahead                                        
                                        v-model="query"
                                        :data="boatsEnrollment"
                                        :serializer="item => item.name_boat"
                                        @hit="mSelectedBoat"
                                        :placeholder="searchType"
                                        v-if="viewSearch"
                                    />
                                    <vue-bootstrap-typeahead                                        
                                        v-model="query"
                                        :data="boatsEnrollment"
                                        :serializer="item => (item.enrollment ? item.enrollment:item.enrollment_old)"
                                        @hit="mSelectedBoat"
                                        :placeholder="searchType"
                                        v-else
                                    />
                                </div>
                            </div>
                        </div>
                        
                        <div>
                            <h6><span class="badge badge-info">Nave {{ selectedBoat.name_boat }}</span></h6>

                            <div class="form-row">
                                <div class="form-group col-12 col-md-6">
                                    <label for="name_ship" class="badge badge-primary">Nombre Nave</label>
                                    <input type="text" class="form-control" v-model="selectedBoat.name_boat" :readonly="is_disabled ? true:false ">
                                </div>
                                <div class="form-group col-12 col-md-6">
                                    <label for="enrollment_ship" class="badge badge-primary">Matricula Nave</label>
                                    
                                    <input v-if="selectedBoat.enrollment" type="text" class="form-control" v-model="selectedBoat.enrollment" :readonly="is_disabled ? true:false ">
                                    <input v-else-if="selectedBoat.enrollment_old" type="text" class="form-control" v-model="selectedBoat.enrollment_old" :readonly="is_disabled ? true:false ">
                                    <input v-else type="text" class="form-control" v-model="selectedBoat.enrollment" :readonly="is_disabled ? true:false ">
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-12 col-md-6">
                                    <label for="type_ship" class="badge badge-primary">Tipo Nave</label>
                                    
                                    <input v-if="is_disabled" type="text" class="form-control" name="type_ship" v-model="selectedBoat.detail_boat" :readonly="is_disabled ? true:false ">

                                
                                    <select v-else class="form-control" v-model="type_boat" name="propulsion">
                                        <option v-for="boat in types_boat" :key="boat.id" :value="boat.detail">{{ boat.detail }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-12 col-md-6">
                                    <label for="enrollment_ship" class="badge badge-primary">Propulsion</label>
                                    
                                    <input type="text" class="form-control" name="type_ship" v-model="selectedBoat.detail_propulsion" v-if="selectedBoat.detail_propulsion" :readonly="is_disabled ? true:false ">

                                    <select v-else class="form-control" v-model="propulsion_aux" name="propulsion" >
                                        <option v-for="motor in propulsiones" :key="motor.id" :value="motor">{{ motor.detail }}</option>
                                    </select>                                    
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-12 col-md-6">
                                    <label for="flag_ship" class="badge badge-primary">Bandera</label>
                                    <input type="text" class="form-control" name="flag_ship" v-model="selectedBoat.flag_boat" v-if="selectedBoat.flag_boat" :readonly="is_disabled ? true:false ">
                                    <select v-else class="form-control" name="bandera_embarcacion" v-model="bandera">
                                        <option v-for="flag in banderas" :value="flag" :key="flag.id">{{ flag.detail }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-6 col-md-3">
                                    <label for="trb_ship" class="badge badge-primary">TRB</label>
                                    <input type="number" class="form-control" v-model="selectedBoat.trb" :readonly="is_disabled ? true:false ">
                                </div>
                                <div class="form-group col-6 col-md-3">
                                    <label for="trn_ship" class="badge badge-primary">TRN</label>
                                    <input type="number" class="form-control" v-model="selectedBoat.trn" :readonly="is_disabled ? true:false ">
                                </div>
                            </div>
                            
                            <div class="form-row">
                                <div class="form-group col-12 col-md-6">
                                    <label for="type_load" class="badge badge-primary">Detalle Carga</label>
                                        <vue-bootstrap-typeahead                                        
                                            v-model="load_aux_query"
                                            :data="loads_type"
                                            :serializer="item => item.carga_detail"
                                            @hit="mSelectLoad"
                                            :placeholder="dOPlaceLoad"
                                        />
                                </div>

                                <div class="form-group col-12 col-md-6">
                                    <label for="type_activity" class="badge badge-primary">Tipo de servicio</label>
                                    <input class="form-control" type="text" disabled="disabled" v-model="aux_activity.service" />
                            
                                </div>
                            </div>
                            
                            <transition name="fade" mode="out-in">
                            <div v-if="d_view_passenger">
                                <h6><span class="badge badge-primary">Cantidad Pasajeros</span></h6>
                                    <div class="form-row">
                                        <div class="col-12 col-md-6">
                                            <h6><span class="badge badge-success">Bolivianos</span></h6>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="inputGroup-sizing-default">Hombre</span>
                                                </div>
                                                <input type="number" v-model="national_men" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                            </div>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="inputGroup-sizing-default">Mujer</span>
                                                </div>
                                                <input type="number" class="form-control" v-model="national_women" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <h6><span class="badge badge-success">Extranjeros</span></h6>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="inputGroup-sizing-default">Hombre</span>
                                                </div>
                                                <input type="number" v-model="foreign_men" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                            </div>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="inputGroup-sizing-default">Mujer</span>
                                                </div>
                                                <input type="number" v-model="foreign_women" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                            </div>
                                        </div>
                                    </div>                        
                                </div>
                                </transition>
                            </div>

                            <transition name="fade" mode="out-in">
                            <div class="form-row" v-if="d_view_kilo">                                    
                                <div class="form-group col-12 col-md-8">
                                    <div class="row">
                                            
                                        <div class="col-6 col-md-6">
                                            <label for="load_cash_kilo" class="badge badge-info">Kilos</label>
                                            <input type="number" v-model="load_cash_kilo" @keyup="calcKiloTonelada" class="form-control" aria-label="Default" placeholder="Kilos" aria-describedby="inputGroup-sizing-default">    
                                        </div>
                                        <div class="col-6 col-md-6">
                                            <label for="load_cash_tonelada" class="badge badge-info">Toneladas</label>
                                            <input type="number" v-model="load_cash_tonelada" @keyup="calcToneladaKilo" class="form-control" aria-label="Default" placeholder="Toneladas" aria-describedby="inputGroup-sizing-default">
                                        </div>
                                    </div>                                        
                                </div>
                                <transition name="fade" mode="out-in">
                                    <div class="form-group col-12 col-md-4" v-if="d_view_rodada">
                                        <label for="load_quantity" class="badge badge-info">Cantidad</label>
                                        <input type="number" v-model="d_quantity" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default" placeholder="Cantidad">
                                    </div>
                                </transition>
                            </div>
                            </transition>

                            <transition name="fade" mode="out-in">
                            <div class="form-row" v-if="d_view_litro">
                                <div class="form-group col-12 col-md-4">
                                    <label for="load_cash_kilo" class="badge badge-info">Liquido (litros)</label>
                                    <input type="number" v-model="load_cash_litro" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                </div>
                            </div>
                            </transition>                                          
                            <!-- <pre>{{ selectedBoat }}</pre>
                            <pre>{{ propulsion_aux }}</pre> -->
                        </div>               
                    
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-info" @click="mSearchEnrollRelapse"><font-awesome-icon icon="check" size="lg" /> Validar</button>
                        <button type="button" class="btn btn-outline-success" @click="mValidateShip"><font-awesome-icon icon="save" size="lg" /> Agregar</button>
                        <button type="button" class="btn btn-outline-warning" @click="mResetForm"><font-awesome-icon icon="redo-alt" size="lg" /> Limpiar</button>
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /> Cerrar</button>
                        
                    </div>
                </div>

                <div class="modal-content" v-if="view">
                    <div class="modal-header">
                        <h5 class="modal-title">Listado de Embarcaciones secundarias</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body table-responsive">
                        <table class="table table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th>#</th>
                                    <th>Nombre</th>
                                    <th>Matricula</th>
                                    <th>TRB</th>
                                    <th>Tarifa <br> Individual</th>
                                    <th>Bandera</th>
                                    <th># Reincidencia</th>
                                    <th>Eliminar</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(boat, index) in retShips" :key="boat.enrollment">
                                    <th scope="row">{{ index+1 }}</th>
                                    <td>{{ boat.name_boat | mayuscula }}</td>
                                    <td>{{ boat.enrollment | mayuscula }}</td>
                                    <td>{{ boat.trb }}</td>
                                    <td>{{ boat.tarifa }}</td>
                                    <td>{{ boat.flag_boat }}</td>
                                    <td>{{ boat.number_relapse }}</td>
                                    <td><button class="btn btn-outline-warning" @click="mDeleteShip(boat.enrollment)"><font-awesome-icon icon="minus-circle"/> </button></td>
                                </tr>
                            </tbody>
                            
                        </table>                       
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal"><font-awesome-icon icon="times-circle" size="lg" /></button>
                    </div>
                </div>

            </div>
    </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
const qs= require('qs');

export default {
    name:'modal-other-ship',
    props:{
        idModal:String,
        register:Boolean,
        view:Boolean,
        banderas:Array,
        types_boat:Array
    },
    data() {
        return {
            query: '',
            selectedBoat: {
                id_boat:0,
                name_boat:null,
                enrollment:null,
                enrollment_old:null,
                detail_boat:null,
                detail_propulsion:null,
                trb:null,
                trn:null,
                factor_propulsion:null,
                factor_penalty:null,
                flag:null,
                flag_boat:null
            },
            propulsion_aux:null,
            boatsEnrollment: [],
            optionSearch:'name',
            vSearch:false,
            propulsiones:null,
            total_form:0,
            is_disabled:false,
            bandera:null,
            type_boat:null,
            load_aux_query:null,
            loads_type:[],
            dOPlaceLoad:'Descripcion Carga',
            actividad:[],
            aux_activity:[],
            national_men:null,
            national_women:null,
            foreign_men:null,
            foreign_women:null,
            load_cash_kilo:null,
            load_cash_tonelada:null,
            load_cash_litro:null,
            d_view_kilo:false,
            d_view_litro:false,
            d_view_passenger:false,
            d_view_rodada:false,
            d_quantity:null,
            penalty_dts:{
                enroll:0,
                number_relapse:0,
                factor_relapse:0,
                id_track:0
            }
        }
    },
    mounted(){
        this.callPropulsion(),
        this.stopModal()
    },
    computed:{
        searchType(){
            switch(this.optionSearch){
                case 'name':
                    return 'Nombre de la Nave';
                break;

                case 'enrollment':
                    return 'Matricula de la Nave';
                break;
            }
        },
        viewSearch(){
            switch(this.optionSearch){
                case 'name':
                    this.vSearch=true;
                break;

                case 'enrollment':
                    this.vSearch=false;
                break;
            }
            return this.vSearch;
        },
        retFactors(){
            return this.$store.getters.getFactorSancion
        },
        retShips(){
            return this.$store.getters.getShipsSancion
        },
        cSelectedBoat(){
            return this.selectedBoat;
        }
    },
    watch: {
        // When the query value changes, fetch new results from
        // the API - in practice this action should be debounced
        query(newQuery) {
            
            // axios.get(`searchNameBoat/${this.optionSearch}/${newQuery}`)
            axios.get(`searchNameBoat/${this.optionSearch}/${newQuery}?api_token=${Vue.auth.getToken()}`)            
                .then((res) => {
                    
                    this.boatsEnrollment = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })               
        },
        load_aux_query(loadQuery){
            
            // axios.get(`searchLoad/${loadQuery}`)
            axios.get(`searchLoad/${loadQuery}?api_token=${Vue.auth.getToken()}`)
                .then((res) => {                    
                    this.loads_type = res.data
                    // this.users = res.data.items
                }).catch(error => {
                    console.log(error);
                })
        }
        // ,
        // selectedBoat(newValue){
        //     this.query=newValue.enrollment;
        // }
    },
    methods:{
        async mSearchEnrollRelapse(){
            let enroll=this.selectedBoat.enrollment ? this.selectedBoat.enrollment : this.selectedBoat.enrollment_old;
            if(enroll !== ' ' && enroll !== null ){                
                let e={
                    enrollment:enroll
                }
                let values_relapse=await axios.post(`searchRelapse?api_token=${Vue.auth.getToken()}`, qs.stringify(e));    
                this.penalty_dts.enroll=values_relapse.data[0].enroll;
                this.penalty_dts.number_relapse=values_relapse.data[0].n_relapse;
                this.penalty_dts.factor_relapse=values_relapse.data[0].f_relapse;
                this.penalty_dts.id_track=values_relapse.data[0].id_track;
                toastr.info('La nave ha sido validada de manera correctar', 'Informacion');
            }else{
                toastr.warning('Indique la matricula de la nave', 'Advertencia');
            }
            
        },
        mSelectLoad(data){
            // this.type_ship=data.id_master;
            
            this.actividad.id=data.id;
            this.actividad.detail=data.detail;
            this.actividad.factor=data.factor;
            this.aux_activity.activity=data.master_detail;
            this.aux_activity.service=data.detail;
            // this.calculateForm();
            this.viewForm(data.unit_measurement);
        },
        viewForm(data){
            switch(data){
                case 'C':
                    this.d_view_passenger=false;
                    this.d_view_kilo=true;
                    this.d_view_litro=false;
                    this.d_view_rodada=false;
                break;
                case 'L':
                    this.d_view_passenger=false;
                    this.d_view_kilo=false;
                    this.d_view_litro=true;
                    this.d_view_rodada=false;
                break;
                case 'P':
                    this.d_view_passenger=true;
                    this.d_view_kilo=false;
                    this.d_view_litro=false;
                    this.d_view_rodada=false;
                break;
                case 'R':
                    this.d_view_passenger=false;
                    this.d_view_kilo=true;
                    this.d_view_litro=false;
                    this.d_view_rodada=true;
                break;
            }
            
        },
        mDeleteShip(enroll){
            this.$store.dispatch('deleteShipSancion',enroll);
            this.$store.dispatch('updateShipSancion',true);
        },
        stopModal(){
            $('.modal').modal({
                keyboard: false,
                show:false,
                backdrop:'static'
            });
        },
        callPropulsion(){
            let propulsion={
                parent:4
            }
            
            // axios.post(`submenu`, qs.stringify(propulsion))
            axios.post(`submenu?api_token=${Vue.auth.getToken()}`, qs.stringify(propulsion))
            .then(res => {                
                this.propulsiones=res.data
                // console.log(this.propulsiones)
            })
        },
        mAppendShip(){
            
            let description_load_aux;
            let d_quantity_aux;
            d_quantity_aux=this.d_quantity ? this.d_quantity : 0;    
                if(this.d_view_rodada){               
                    description_load_aux=this.load_aux_query+' cant. '+d_quantity_aux;
                }else{
                    description_load_aux=this.load_aux_query ? this.load_aux_query : '';
                }
            
            let ship={
                id_boat: this.selectedBoat.id ? parseInt(this.selectedBoat.id) : 0,
                enrollment:this.selectedBoat.enrollment ? this.selectedBoat.enrollment:this.selectedBoat.enrollment_old,
                name_boat:this.selectedBoat.name_boat,
                trn:parseFloat(this.selectedBoat.trn),
                trb:parseFloat(this.selectedBoat.trb),
                detail_boat:this.selectedBoat.detail_boat ? this.selectedBoat.detail_boat : this.type_boat,
                detail_propulsion:this.selectedBoat.detail_propulsion ? this.selectedBoat.detail_propulsion : this.propulsion_aux.detail,                
                factor_propulsion:this.selectedBoat.factor ? parseFloat(this.selectedBoat.factor) : parseFloat(this.propulsion_aux.factor),
                factor_navigate:parseFloat(this.retFactors.navigate),
                factor_activity:this.actividad.factor ? parseFloat(this.actividad.factor) :0.0,
                service:this.actividad.id,
                type_service:this.actividad.detail, 
                tarifa:parseFloat(this.total_form),
                kilos: this.load_cash_kilo ? parseFloat(this.load_cash_kilo) : 0,
                tonelada:this.load_cash_tonelada ? parseFloat(this.load_cash_tonelada) : 0,
                litros:this.load_cash_litro ? parseFloat(this.load_cash_litro) :0,
                national_man:this.national_men ? parseInt(this.national_men) : 0,
                national_woman:this.national_women ? parseInt(this.national_women):0,
                foreign_man:this.foreign_men ? parseInt(this.foreign_men) : 0,
                foreign_woman:this.foreign_women ? parseInt(this.foreign_women) : 0,                
                description_load:description_load_aux,
                flag:this.selectedBoat.flag ? parseInt(this.selectedBoat.flag) : parseInt(this.bandera.id),
                flag_boat:this.selectedBoat.flag_boat ? this.selectedBoat.flag_boat: this.bandera.detail,
                type:'s',
                type_sancion:'M',
                number_relapse:this.penalty_dts.number_relapse,
                factor_relapse:this.penalty_dts.factor_relapse,
                id_track:this.penalty_dts.id_track,
                quantity:d_quantity_aux
            }

                    
            // aqui considerar que no accedemos a la anterior pantalla por ende no sabemos si el valor del dia es mayor a cero analizar
            // sugerencia crear en el store un parametro que maneje los dias laburados asi sabremos si esta o no habilitado inclusive si se llego a aplicar el metodo de dragado.
            
            this.$store.dispatch('addShipSancion', ship);
            this.$store.dispatch('updateShipSancion',true);
            toastr.success('Embarcacion Agregada Correctamente', 'Nota');
            this.mResetForm();
        },
        mValidateShip(){
            
            if(this.penalty_dts.enroll !== 0 && this.penalty_dts.number_relapse >0 && this.penalty_dts.factor_relapse > 0){
                if(parseFloat(this.selectedBoat.trb) > parseFloat(this.selectedBoat.trn)) {
                    if( (this.selectedBoat.enrollment || this.selectedBoat.enrollment_old) && this.selectedBoat.name_boat && this.selectedBoat.trb && (this.selectedBoat.factor_propulsion || this.propulsion_aux.factor_penalty) && (this.selectedBoat.detail_propulsion || this.propulsion_aux.detail) && (this.selectedBoat.detail_boat || this.type_boat) && this.actividad.id ){

                       if(parseFloat(this.load_cash_kilo) > 0.1 || parseFloat(this.load_cash_tonelada) > 0.1 || parseFloat(this.load_cash_litro) > 0.1 || parseInt(this.national_men) > 0.1 || parseInt(this.national_women) > 0.1 || parseInt(this.foreign_men) > 0.1 || parseInt(this.foreign_women) > 0.1 ){
                            this.mAppendShip();
                        }else{
                            toastr.warning('Verifique que la cantidad de la carga este completa, si la carga es cero porfavor digite 0.1 ','Advertencia');
                        }
                    }else{
                        toastr.warning('Verifique que los campos esten completos ','Advertencia');
                    }
                }else{
                    toastr.warning('Verifique el TRN ','Advertencia');
                }
            }else{
                toastr.warning('Presione el boton Validar','Advertencia');
            }
        },
        mSelectedBoat(data){
            this.is_disabled=true;
            this.selectedBoat=data;
        },
        mResetForm(){
            this.is_disabled=false;
            this.query=null;
            this.selectedBoat={
                id:0,
                name_boat:null,
                enrollment:null,
                detail_boat:null,
                detail_propulsion:null,
                trb:null,
                trn:null,
                factor_propulsion:null,
                propulsion:null,
                factor_penalty:null
            };
            // this.d_view_passenger=false;
            // this.d_view_kilo=false;
            // this.d_view_litro=false;
            // this.d_view_rodada=false;
            this.d_quantity=null;
            this.national_men=null;
            this.national_women=null;
            this.foreign_men=null;
            this.foreign_women=null;
            this.load_cash_kilo=null;
            this.load_cash_tonelada=null;
            this.load_cash_litro=null;
        },
        calcToneladaKilo(){
            this.load_cash_kilo=this.load_cash_tonelada*1000;
        },
        calcKiloTonelada(){
            this.load_cash_tonelada=this.load_cash_kilo/1000;
        }
    },
    filters: {
        stringify(value) {
            return JSON.stringify(value, null, 2)
        },
        mayuscula:function(value){
            if (!value) return '';
            return value = value.toUpperCase();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/cotizacion/modalOtherShipSancion.vue